const portfolioProjects = [
    {
        title: "Minimal Portfolio",
        description: "Created in React with React Bootstrap. Simple clean and minimal.",
        githubLink: "https://github.com/stevenmcstravog/stevenmcstravog.github.io",
        demoLink: "http://stevenmcstravog.github.io/"
    },
    {
        title: "Horror Movie Quiz",
        description: "Created in React with React Bootstrap. Using useState and useEffect with a simple JS shuffle to mix the questions.",
        githubLink: "https://github.com/stevenmcstravog/horror-movie-quiz",
        demoLink: "https://stevenmcstravog.github.io/horror-movie-quiz/"
    }
]

const employment = [
    {
        company: "Selazar",
        title: "Lead Front End Developer / Head of Feature Development",
        date: "April 2019  - Present",
        stack: ["React JS", "SCSS", "Bootstrap", ".NET core", "Xamarin", "SQL Server", "Linq to SQL"]
    },
    {
        company: "Fluent Technology",
        title: "Solutions Developer",
        date: "October 2015 - April 2019",
        stack: ["React JS", "SCSS", "CSS", "Cucumber/Selenium", ".NET core", "ASP.NET", "VB.NET", "JQuery", "Kendo UI", "SQL Server", "T-SQL"]
    },
    {
        company: "Send My Bag",
        title: "Software Engineer",
        date: "October 2014 - September 2015",
        stack: ["ASP.NET MVC", "partial views (Razor)", "C#", "Linq to SQL"]
    },
    {
        company: "Freelance",
        title: "Software Engineer",
        date: "October 2014 - September 2015",
        stack: ["Unity Game Engine", "C#"]
    },
    {
        company: "ServaSport",
        title: "Lead Developer",
        date: "October 2014 - September 2015",
        stack: ["Java", "Spring", "Hibernate", "MySQL", "Bootstrap"]
    }
]

export {
    portfolioProjects,
    employment
};
